// /publicCenters 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 6개를 이 배열 하나로 대체한다. field 키 / operator / 옵션값 동일.

import type { SearchFieldConfig } from "components/list";

export const publicCentersSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "name", label: "이름", type: "text", operator: "contains", width: 200 },
  {
    name: "kindOf",
    label: "종류",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "ChildHouse", label: "어린이집" },
      { value: "Kindergarten", label: "유치원" },
    ],
  },
  { name: "address", label: "주소", type: "text", operator: "contains", width: 200 },
  { name: "tel", label: "전화번호", type: "text", operator: "contains", width: 200 },
  {
    name: "status",
    label: "상태",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "정상", label: "정상" },
      { value: "폐지", label: "폐지" },
    ],
  },
];
